import React from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const Wrapper = styled.button`
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  font-weight: 500;
  opacity: ${props => {
    let opacity = '0.6';
    if (props.selected) opacity = '1';
    return opacity;
  }};
  color: ${props => {
    let color = props => props.theme.color.dark_100;
    if (props.selected) color = props => props.theme.color.font_fff;;
    return color;
  }};
  border: 1px solid ${props => {
    let color = props.theme.color.default_border_color;
    if (props.selected) color = 'transparent';
    return color;
  }};
  background-color: ${props => {
    let color =  props.theme.color.site_main_color;
    if (props.selected) color = props.theme.color.default_border_color;
    return color;
  }};
  padding: 6px 12px;
  font-size: 12px;
  margin-right: 6px;
`;
const SummonerMasteryPatch = ({selected, patch, onClick}) => {
    const {t} = useTranslation()
    return (
        <Wrapper selected={selected} onClick={onClick}>
            {patch === 'All' ? t('summoner.mastery.allPatches') : `Patch ${patch}`}
        </Wrapper>
    );
};

export default SummonerMasteryPatch;